import React from "react";

import style from "./style.module.css";
import formatUrl from "utils/FormatUrl";
import { useRouter } from "next/router";
import { handleDate } from "utils/handleDate";
import moment from "moment";

function index(props) {
  const { asPath } = useRouter();

  return (
    <div className={style.container}>
      <div className={style.innerContainer}>
        <p className={style.title}>{props.title}</p>
        <div className={style.array}>
          {props.linkArticles.map((item, key) => {
            return (
              <div className={style.tableItem} key={key}>
                <a
                  target="_blank"
                  rel={
                    item.slug.current.includes("list") ||
                    item.slug.current.includes("map") ||
                    item.slug.current.includes("?") ||
                    item.slug.current.includes("conditions") ||
                    item.slug.current.includes("contact")
                      ? "nofollow noopener noreferrer noindex"
                      : "follow noopener"
                  }
                  href={formatUrl(`${asPath}/${item.slug.current}`, props.lang)}
                >
                  {item.title[props.lang]}
                </a>
                <span dir={props.lang === "ar" ? "rtl" : "ltr"}>{`${handleDate(
                  item._createdAt,
                  props.lang
                )}`}</span>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default index;
